import get from 'lodash/get';
import type { PaymentMethodAPIPayload } from 'src/types/paymentMethod.types';

export const canEditPaymentMethod = (pm: PaymentMethodAPIPayload) =>
  (get(pm, 'supported-operations.modify_name_and_description.enabled') ||
    get(pm, 'supported-operations.modify_billing_info.enabled')) ??
  false;

export const canDeletePaymentMethod = (pm: PaymentMethodAPIPayload) =>
  get(pm, 'supported-operations.delete_paymentmethod.enabled') ?? false;
